/**
 * DoseFromDeltaButton — "Raise to ideal →" / "Lower to ideal →" button (bonus B).
 *
 * Deep-links to Stock Solutions Dose Calculator with current/target/unit pre-filled.
 * Shared by TestRunnerModal result screen and ActionPlanModal.
 */
import { useNavigate } from 'react-router-dom';
import {
  getIdealRangeForParameter,
  classifyResult,
  stockSolutionKeyForParameter,
} from '@reefapp/shared';
import type { ParameterKey } from '@reefapp/shared';

export interface DoseFromDeltaButtonProps {
  parameterKey: ParameterKey;
  currentValue: number;
  unit: string;
}

export function DoseFromDeltaButton({
  parameterKey,
  currentValue,
  unit,
}: DoseFromDeltaButtonProps) {
  const navigate = useNavigate();

  const solutionKey = stockSolutionKeyForParameter(parameterKey);
  const idealRange = getIdealRangeForParameter(parameterKey);
  const classification = classifyResult(parameterKey, currentValue);

  if (!solutionKey || !idealRange || classification === 'ideal' || classification === 'unknown') {
    return null;
  }

  const idealMid = (idealRange.min + idealRange.max) / 2;
  const label =
    classification === 'low' ? 'Raise to ideal →' : 'Lower to ideal →';
  const searchParams = new URLSearchParams({
    solution: solutionKey,
    current: String(currentValue),
    target: String(idealMid),
    unit,
  });

  return (
    <button
      onClick={() =>
        navigate(`/stock-solutions?${searchParams.toString()}`)
      }
      className="mt-3 w-full px-4 py-2 rounded-md text-sm font-semibold bg-cyan-600 text-white hover:bg-cyan-500 transition-colors"
    >
      {label}
    </button>
  );
}
